module.exports = __webpack_public_path__ + "img/u1834.3cdf3db5.png";